<template>
  <JetModal
    :show="isOpen"
    :max-width="'2xl'"
    :closeable="true"
    @close="isOpen = false"
  >
    <div class="px-6 py-4">
      <div>
        <label
          for="comment"
          class="block text-sm font-medium text-gray-700"
          >LinkedIn ID's</label
        >
        <div class="mt-1">
          <textarea
            rows="4"
            v-model="usernames"
            placeholder="Comma seperated LinkedIn ID's"
            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="flex justify-end rounded-b-lg bg-gray-100 px-6 py-4">
      <JetSecondaryButton @click="isOpen = false"> Close </JetSecondaryButton>
      <JetButton
        class="ml-2"
        @click="processLinkedInProfiles"
        :class="{'opacity-25': processing}"
        :disabled="processing"
      >
        Import Profiles
      </JetButton>
    </div>
  </JetModal>
</template>

<script setup>
import {ref, onMounted, onUnmounted} from 'vue';
import axios from 'axios';
import {notify} from 'notiwind';
import JetModal from '@/Jetstream/Modal.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
import JetButton from '@/Jetstream/Button.vue';

const isOpen = ref(false);
const processing = ref(false);
const usernames = ref('');

const onKeyDown = event => {
  if (isOpen.value) {
    return;
  }

  if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
    isOpen.value = true;
  }
};

const processLinkedInProfiles = () => {
  processing.value = true;
  axios
    .post(route('import.linkedin.talents'), {
      usernames: usernames.value,
    })
    .then(response => {
      processing.value = false;
      isOpen.value = false;
      usernames.value = '';
      notify({
        title: 'Success',
        description: 'LinkedIn usernames will be processed soon by the queue system.',
        type: 'success',
      });
    })
    .catch(error => {
      processing.value = false;
      notify({
        title: 'Error',
        description: 'Something went wrong.',
        type: 'error',
      });
    });
};

onMounted(() => window.addEventListener('keydown', onKeyDown));
onUnmounted(() => window.removeEventListener('keydown', onKeyDown));
</script>
